// // src/components/BlogPost.jsx
// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import Markdown from './Markdown';
// import metadata from '../content/metadata.json';
// import '../styles/BlogPost.css';

// const BlogPost = () => {
//   const { slug } = useParams();
//   const [post, setPost] = useState(null);
//   const [content, setContent] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogPost = async () => {
//       try {
//         // Find post metadata
//         const foundPost = metadata.find(p => p.slug === slug);
        
//         if (!foundPost) {
//           throw new Error('Blog post not found');
//         }
        
//         setPost(foundPost);
        
//         // Fetch markdown content
//         const response = await fetch(`/content/blogs/${slug}.md`);
        
//         if (!response.ok) {
//           throw new Error('Failed to load blog content');
//         }
        
//         const text = await response.text();
//         setContent(text);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };
    
//     fetchBlogPost();
//   }, [slug]);

//   if (loading) {
//     return <div className="blog-post-loading">Loading...</div>;
//   }

//   if (error) {
//     return <div className="blog-post-error">Error: {error}</div>;
//   }

//   if (!post) {
//     return <div className="blog-post-not-found">Blog post not found</div>;
//   }

//   return (
//     <div className="blog-post-container">
//       <Link to="/" className="blog-post-back">
//         ← Back to all articles
//       </Link>
      
//       <div className="blog-post-header">
//         {post.category && (
//           <div className="blog-post-category">{post.category}</div>
//         )}
//         <h1 className="blog-post-title">{post.title}</h1>
        
//         <div className="blog-post-meta">
//           <div className="blog-post-author">
//             {post.authorImage && (
//               <img 
//                 src={post.authorImage} 
//                 alt={post.author} 
//                 className="blog-post-author-image" 
//               />
//             )}
//             <span>{post.author}</span>
//           </div>
          
//           {post.date && (
//             <div className="blog-post-date">{post.date}</div>
//           )}
//         </div>
//       </div>
      
//       {post.coverImage && (
//         <div className="blog-post-cover">
//           <img src={post.coverImage} alt={post.title} />
//         </div>
//       )}
      
//       <div className="blog-post-content">
//         <Markdown content={content} />
//       </div>
      
//       {post.tags && post.tags.length > 0 && (
//         <div className="blog-post-tags">
//           {post.tags.map(tag => (
//             <span key={tag} className="blog-post-tag">#{tag}</span>
//           ))}
//         </div>
//       )}
      
//       <div className="blog-post-navigation">
//         <Link to="/" className="blog-post-nav-button">
//           See more articles
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default BlogPost;




// src/components/BlogPost.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Markdown from './Markdown';
import metadata from '../content/metadata.json';
import { extractFrontMatter } from '../utils/markdownUtils';
import '../styles/BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        // Find post metadata
        const foundPost = metadata.find(p => p.slug === slug);
        
        if (!foundPost) {
          throw new Error('Blog post not found');
        }
        
        setPost(foundPost);
        
        // Important change: Use the correct path to the markdown file
        // This now uses a relative path that matches your project structure
        const response = await fetch(`${process.env.PUBLIC_URL}/content/blogs/${slug}.md`);

        
        if (!response.ok) {
          throw new Error(`Failed to load blog content: ${response.status} ${response.statusText}`);
        }
        
        const text = await response.text();
        const { content: cleanContent } = extractFrontMatter(text);
        setContent(cleanContent);
        setLoading(false);
      } catch (err) {
        console.error('Error loading blog post:', err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    fetchBlogPost();
  }, [slug]);

  if (loading) {
    return <div className="blog-post-loading">Loading...</div>;
  }

  if (error) {
    return <div className="blog-post-error">Error: {error}</div>;
  }

  if (!post) {
    return <div className="blog-post-not-found">Blog post not found</div>;
  }

  return (
    <div className="blog-post-container">
      <Link to="/" className="blog-post-back">
        ← Back to all articles
      </Link>
      
      <div className="blog-post-header">
        {post.category && (
          <div className="blog-post-category">{post.category}</div>
        )}
        <h1 className="blog-post-title">{post.title}</h1>
        
        <div className="blog-post-meta">
          <div className="blog-post-author">
            {post.authorImage && (
              <img 
                src={`${process.env.PUBLIC_URL}${post.authorImage}`} 
                alt={post.author} 
                className="blog-post-author-image" 
              />
            )}
            <span>{post.author}</span>
          </div>
          
          {post.date && (
            <div className="blog-post-date">{post.date}</div>
          )}
        </div>
      </div>
      
      {post.coverImage && (
        <div className="blog-post-cover">
          <img src={`${process.env.PUBLIC_URL}${post.coverImage}`} alt={post.title} />
        </div>
      )}
      
      <div className="blog-post-content">
        <Markdown content={content} />
      </div>
      
      {post.tags && post.tags.length > 0 && (
        <div className="blog-post-tags">
          {post.tags.map(tag => (
            <span key={tag} className="blog-post-tag">#{tag}</span>
          ))}
        </div>
      )}
      
      <div className="blog-post-navigation">
        <Link to="/" className="blog-post-nav-button">
          See more articles
        </Link>
      </div>
    </div>
  );
};

export default BlogPost;